import index from './form-timepicker'

export default index